export default {
  region: "ap-southeast-2",
  IdentityPoolId: "ap-southeast-2_UpfAzThcT",
  UserPoolId: "ap-southeast-2:693181236168",
  ClientId: "52ciedm2p0c902tfd514b27cf0"
};
